/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import textStyles from '../../foundations/textStyles'

const mapStatusColorScheme = (c) => {
    switch (c) {
        // info
        case 'blue':
            return 'stokkeCore.black'
        // warning
        case 'orange':
            return 'stokkeCore.black'
        // success
        case 'green':
            return 'stokkeFunctional.alertGreen'
        // error
        case 'red':
            return 'stokkeFunctional.alertRed'
        // custom color scheme
        default:
            return c
    }
}

const solidVariant = ({colorScheme: c}) => ({
    container: {
        bg: mapStatusColorScheme(c),
        color: 'stokkeCore.white'
    }
})

const toastVariant = (ctx) => {
    const solid = solidVariant(ctx)
    return {
        ...solid,
        container: {
            ...solid.container,
            // allow the close button to position based on the container
            position: 'relative',
            // define margin here instead of toast container, because toast container doesn't
            // support responsive values
            mx: {
                base: 4,
                lg: 6,
                xl: 8
            },
            mb: 2,
            // clear the component default width: 100% due to the margins
            width: null,
            borderRadius: 'base',
            minHeight: 11.5,
            // space for the close button
            paddingEnd: 12,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 3
        },
        title: {
            ...solid.title,
            // reset
            marginEnd: null,
            // inherit from container
            fontWeight: null,
            lineHeight: null,
            //
            flexDirection: 'column',
            alignItems: 'flex-start',
            ...textStyles['Semi Bold Medium']
        },
        description: {
            ...solid.description,
            ...textStyles['Regular Small']
        }
    }
}

export default {
    baseStyle: {
        container: {
            px: 3,
            py: 3,
            ...textStyles['Regular Medium']
        },
        title: {
            marginEnd: 2.5
        }
    },
    variants: {
        solid: solidVariant,
        subtle: (props) => ({
            container: {
                borderColor: `${props.colorScheme || 'green'}.600`,
                borderWidth: 1,
                borderStyle: 'solid'
            }
        }),
        toast: toastVariant,
        mobileFullWidthDesktopMax25rem: (ctx) => {
            const toast = toastVariant(ctx)
            return {
                ...toast,
                container: {
                    ...toast.container,
                    maxWidth: {lg: '25rem'},
                    width: {base: 'calc(100% - 2rem)', lg: 'auto'}
                }
            }
        }
    },
    defaultProps: {
        variant: 'solid'
    }
}
